import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Button from "@mui/material/Button";
import Card from '@mui/material/Card';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import { ThemeProvider } from "@mui/styles";
import React, { Component } from "react";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import { BlueButton } from "../../components/BlueButton";
import CircularLoading from "../../components/CircularLoading";
import { GetAddresses, GetAddressLine2, GetdeliveryServices } from "../../services/Address";
import { GetCertificateOwnerByID } from "../../services/Product";
import { GetToken, GuestLogin, Me, RefreshSession, SetToken, SetUser } from "../../services/Session";
import { CreateOrder } from "../../services/Transaction";
import "../../styles/style.css";
import theme from "../../styles/theme";

const BackIcon = "/assets/svg/back.svg";

class NewOrderCertificate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			product_id: this.props.location.state.product_id,
			product_code: this.props.location.state.product_code,
			product_name: this.props.location.state.product_name,
			unit_price: this.props.location.state.unit_price,
			selectedAddress: {},
			loading: false,
			loading_address: false,
			open_modal_delivery: false,
			open_alert_submit: false,
			weight: 1,
			item_list: [{
				product_id: this.props.location.state.product_id,
				product_code: this.props.location.state.product_code,
				product_name: this.props.location.state.product_name,
				unit_price: this.props.location.state.unit_price,
				certificates: [],
				selected_certificates: [],
				subtotal: 0,
				qty: 0,
				weight: 1,
			}],
			delivery_service: [],
			selected_delivery: {},
			delivery_cost: 0,
			...this.props.location.state
		}
		if (!this.state.subtotal) {
			this.state.subtotal = this.state.unit_price;
		}
		if (!this.state.delivery_cost) {
			this.state.delivery_cost = 0;
		}
	}

	componentDidMount = async () => {
		this.handleGetAddresses()
	}

	addCertificateOwner = async () => {
		const { product_id, product_code, product_name, unit_price } = this.state
		this.setState(state => {
			const newitem = {
				product_id: product_id,
				product_code: product_code,
				product_name: product_name,
				unit_price: unit_price,
				certificates: [],
				selected_certificates: [],
				subtotal: 0,
				qty: 0,
				weight: 1,
			};
			const item_list = [...state.item_list, newitem];
			return {
				item_list,
				selected_delivery: {},
				delivery_service: [],
				delivery_cost: 0,
			};
		})
	}

	setLineItems = item_list => {
		let line_items = []
		item_list.forEach(item => {
			if (item.selected_certificates !== undefined) {
				item.selected_certificates.forEach(certNo => {
					line_items.push({
						"certificate": {
							"nip": item.selected_nip,
							"name": item.student_name,
							"number": certNo,
						},
						"product": {
							"id": item.product_id,
						},
						"quantity": 1,
					})
				})
			}
		})
		return line_items
	}

	handlePostOrder = () => {
		const { product_name, item_list, selectedAddress, weight } = this.state
		if (this.ableToSubmitOrder()) {
			this.setState({ loading: true });
			CreateOrder({
				description: product_name || 'Syahadah Cetak HSI AbdullahRoy',
				line_items: this.setLineItems(item_list),
				delivery_service: {
					destination_address: {
						id: selectedAddress.id
					},
					weight: weight,
				},
			}).then(res => {
				this.setState({
					loading: false,
				});
				this.props.history.push({
					pathname: `/transaksi/${res.data.number}`,
					state: {
						order_detail: res.data,
					}
				});
			})
				.catch(err => {
					this.setState({ loading: false });
					if (err.response) {
						if (err.response.status === 401) {
							if (GetToken().refresh_token !== null) {
								RefreshSession();
								setTimeout(this.handlePostOrder(), 3000)
							} else {
								alert("gagal terhubung ke server");
								this.handleLogout()
							}
						} else if (err.response.data.error && err.response.data.error && err.response.data.error.message) {
							alert(err.response.data.error.message);
						} else {
							alert("gagal terhubung ke server");
						}
					} else {
						alert("gagal terhubung ke server");
					}
				});
		} else {
			this.handleToggleSubmitOrder()
		}
	}

	handleLogout = () => {
		GuestLogin().then(res => {
			Me(SetToken(res.data.token).access_token).then(res => {
				SetUser(res.data)
				setTimeout(this.props.history.push('/'), 3000)
			})
		})
	}

	handleCheckNIP = (nip, index) => {
		const { item_list } = this.state
		let itemList = [...item_list];
		if (nip) {
			GetCertificateOwnerByID(nip)
				.then(res => {
					if (res.data !== undefined) {
						let weight = 85
						res.data.certificates.forEach(c => { 
							const match = c.level_info?.match(/^([A-Z]+)?L?(\d+)-/);
							c.sort_number = !match ? 0 : match[1] === "MHZ" ? 10 : 20 + parseInt(match[2])
						})
						itemList[index].selected_nip = res.data.nip
						itemList[index].nip = res.data.nip
						itemList[index].student_name = res.data.name
						itemList[index].certificates = res.data.certificates
						itemList[index].weight = weight
						this.setState({ item_list: itemList, weight: weight })
					}
				})
				.catch(err => {
					alert('NIP ' + nip + ' tidak ditemukan')
				})
		}
		this.setState({ item_list: itemList })

	}
	handleChangeText = (name, index) => event => {
		const { item_list } = this.state
		let itemList = [...item_list];
		itemList[index][name] = (name === 'student_id_number') ? event.target.value.toUpperCase() : event.target.value
		this.setState({ item_list: itemList })
	}

	handleChangeCheckbox = (certNo, index) => {
		const { item_list } = this.state
		let itemList = [...item_list];
		if (!this.handleCheckCheckbox(certNo, index)) {
			itemList[index].selected_certificates.push(certNo)
		} else {
			itemList[index].selected_certificates = item_list[index].selected_certificates.filter((id, _idx) => id !== certNo)
		}
		itemList[index].qty = itemList[index].selected_certificates.length
		itemList[index].subtotal = itemList[index].qty * itemList[index].unit_price
		this.setState({
			item_list: itemList,
			selected_delivery: {},
			delivery_service: [],
			delivery_cost: 0,
		})
	}

	handleCheckCheckbox = (certNo, index) => {
		const { item_list } = this.state
		if (item_list[index] !== undefined && item_list[index].selected_certificates !== undefined) {
			return item_list[index].selected_certificates.includes(certNo)
		} else {
			return false
		}
	}

	handleGetAddresses = () => {
		const { state } = this.props.location;

		if (state?.selectedAddress) {
			this.setState({
				selectedAddress: state.selectedAddress,
			});

			return;
		}

		this.setState({ loading_address: true });

		GetAddresses({ is_primary: true })
			.then((res) => {
				this.setState({
					loading_address: false,
				});
				if (res.data.results.length > 0) {
					this.setState({
						selectedAddress: res.data.results[0],
					});
				}
			})
			.catch((err) => {
				this.setState({ loading: false });
				if (err.response) {
					if (err.response.status === 401) {
						if (GetToken().refresh_token !== null) {
							RefreshSession();
							setTimeout(this.handleGetAddresses(), 3000);
						} else {
							alert('gagal terhubung ke server');
							this.handleLogout();
						}
					} else if (err.response.data.error && err.response.data.error && err.response.data.error.message) {
						alert(err.response.data.error.message);
					} else {
						alert('gagal terhubung ke server');
					}
				} else {
					alert('gagal terhubung ke server');
				}
			})
	}

	totalWeight = () => {
		const { item_list } = this.state
		let total_weight = 0
		item_list.forEach(item => {
			total_weight += (item.weight * item.qty)
		})
		return total_weight
	}

	removeProduct = (index) => {
		const { item_list } = this.state
		let itemList = item_list.filter((item, idx) => idx !== index)
		this.setState({
			item_list: itemList,
			selected_delivery: {},
			delivery_service: [],
			delivery_cost: 0,
		})
	}

	lineItem = () => {
		const { item_list } = this.state
		return (item_list.map((item, idx) => <Card key={idx} className="order-card" style={{ textAlign: "left", height: "auto", width: '90%' }}>
			<div style={{ padding: 10, fontSize: 14, width: '100%' }}>
				<div style={{ paddingBottom: 5 }}><b>{item.product_name}</b></div>
				<Grid container spacing={1}>
					<Grid item xs={6}>
						Biaya Per Level:
					</Grid>
					<Grid item xs={6} style={{ color: "#00bfe6", textAlign: 'right' }}>
						<NumberFormat value={item.unit_price} displayType={"text"} thousandSeparator={"."} decimalSeparator={","} prefix={"Rp "} />
					</Grid>
					<Grid item xs={6}>
						Jumlah Level Dipilih:
					</Grid>
					<Grid item xs={6} style={{ color: "#00bfe6", textAlign: 'right' }}>
						{item.qty || '0'} Pcs
					</Grid>
					<Grid item xs={12}>
						Tentukan NIP dan Nama:
					</Grid>
				</Grid>
				<div className="center" style={{ padding: 10, display: 'flex', alignItems: 'center' }} >
					<TextField
						id="student_id_number"
						name="student_id_number"
						label="NIP"
						value={item.student_id_number || ''}
						variant="outlined"
						size="small"
						style={{ height: 40, width: '100%' }}
						onChange={this.handleChangeText('student_id_number', idx)}
						autoFocus
					/>
					<Button
						variant="contained"
						color="primary"
						style={{ height: 40, marginLeft: 10 }}
						onClick={() => this.handleCheckNIP(item.student_id_number, idx)}
					>Cek</Button>
				</div>
				<div className="center" style={{ padding: 10 }} >
					<TextField
						id="student_name"
						name="student_name"
						label="Nama"
						value={item.student_name || ''}
						variant="outlined"
						size="small"
						style={{ height: 40, width: '100%' }}
						onChange={this.handleChangeText('student_name', idx)}
					/>
					<div style={{ paddingTop: 5 }}><i>* NIP dan Nama diatas akan dicetak pada syahadah, pastikan telah diisi dengan benar</i></div>
				</div>
				{item.certificates !== undefined && (
					<Grid container spacing={1}>
						<Grid item xs={12}>
							Pilih Level:
						</Grid>
						<Grid item xs={12}>
							<FormGroup>
								{item.certificates.sort((a, b) => a.sort_number - b.sort_number).map((c, _i) => {
									if (c.cert_no && c.level_info && c.transcripts) {
										let level_number = c.level_info.split('-')[0]
										let level_name = JSON.parse(c.transcripts).map(item => {
											const [code, , , , , , name] = item.split('|');
											return `${code} ${name}`;
										}).join(', ')
										const label = c.is_printed ? level_number + ' : ' + level_name : <div>{level_number + ' : ' + level_name + ' '}<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#75FB4C"><path d="M120-160q-33 0-56.5-23.5T40-240v-480q0-33 23.5-56.5T120-800h720q33 0 56.5 23.5T920-720v480q0 33-23.5 56.5T840-160H120Zm0-80h720v-480H120v480Zm20-120h50v-140l102 140h48v-240h-50v140L190-600h-50v240Zm240 0h160v-50H440v-44h100v-50H440v-46h100v-50H380v240Zm240 0h160q17 0 28.5-11.5T820-400v-200h-50v180h-44v-140h-50v140h-46v-180h-50v200q0 17 11.5 28.5T620-360ZM120-240v-480 480Z" /></svg></div>
										return (
											<FormControlLabel
												control={
													<Checkbox 
														checked={this.handleCheckCheckbox(c.cert_no, idx)} 
														onChange={() => this.handleChangeCheckbox(c.cert_no, idx)} 
														color="primary" />
												}
												key={c.cert_no}
												label={label}
											/>
										)
									} else {
										return ''
									}
								})}
							</FormGroup>
						</Grid>
					</Grid>
				)}
				<Button size="small" color="secondary" onClick={() => this.removeProduct(idx)} style={{ textTransform: 'none' }} startIcon={<DeleteIcon />}>Hapus</Button>
			</div>
		</Card>
		)
		)
	}

	deliveryAddress = () => {
		const { selectedAddress, loading_address } = this.state;
		return (
			<Card className="order-card" style={{ textAlign: 'left', padding: '0', width: '90%' }}>
				<div style={{ padding: 10, fontSize: 14, width: '100%', position: 'relative' }}>
					<div>
						<b>Alamat Pengiriman:</b>
					</div>
					{loading_address ? (
						<div style={{ display: 'table', margin: '0 auto' }}>
							<CircularLoading />
						</div>
					) : Object.keys(selectedAddress).length === 0 && selectedAddress.constructor === Object ? (
						<Button
							variant="outlined"
							onClick={this.selectAddress}
							color="primary"
							style={{ textTransform: 'none', height: 40, width: '100%', margin: '10px 0 5px' }}
						>
							Tentukan alamat pengiriman
						</Button>
					) : (
						<div onClick={this.selectAddress} style={{ cursor: 'pointer' }}>
							<IconButton
								onClick={this.selectAddress}
								style={{ position: 'absolute', top: '10px', right: '10px' }}
								size="small"
							>
								<EditIcon fontSize="small" />
							</IconButton>
							<div style={{ fontSize: 12 }}>
								<div>
									<b>{selectedAddress.contact_person}</b>
								</div>
								<div>{selectedAddress.complete}</div>
								<div>{GetAddressLine2(selectedAddress)}</div>
								<div>Nomor HP : {selectedAddress.phone}</div>
							</div>
						</div>
					)}
				</div>
			</Card>
		)
	}

	selectAddress = () => {
		const { history, location } = this.props;
		const { item_list } = this.state;

		history.push('/alamat', { ...location.state, item_list });
	}

	ableToSubmitOrder = () => {
		const { selectedAddress, item_list } = this.state;

		if (!Object.keys(selectedAddress).length) {
			return false;
		}
		item_list.forEach(item => {
			if (item.qty === 0 || !item.selected_nip) {
				return false
			}
		})
		return true
	}

	handleToggleSubmitOrder = () => {
		const { open_alert_submit } = this.state
		this.setState({ open_alert_submit: !open_alert_submit })
	}


	modalNotifSubmit = () => {
		const { open_alert_submit, selectedAddress, item_list } = this.state
		let text = []
		let is_selected_nip = true
		let is_selected_qty = true
		item_list.forEach(item => {
			if (!item.selected_nip) {
				is_selected_nip = false
			}
			if (item.qty === 0) {
				is_selected_qty = false
			}
		})
		if (!is_selected_nip) {
			text.push('NIP tidak Valid, tekan tombol "Cek" untuk validasi NIP)')
		}
		if (!is_selected_qty) {
			text.push('Silsilah belum dipilih')
		}
		if (!Object.keys(selectedAddress).length) {
			text.push('Alamat pengiriman belum ditentukan')
		}
		return <Dialog onClose={this.handleToggleSubmitOrder} aria-labelledby="customized-dialog-title" open={open_alert_submit}>
			<DialogTitle id="customized-dialog-title">Perhatian
				<IconButton aria-label="close" style={{ position: 'absolute', right: 10, top: 10 }} onClick={this.handleToggleSubmitOrder}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<div style={{ padding: '0 24px 20px', fontFamily: 'Open Sans' }}>
				Silakan lengkapi data berikut ini:
				{text && <ul>{text.map((t, idx) => <li key={idx}>{t}</li>)}</ul>}
			</div>
		</Dialog>
	}

	render() {
		const subtotal = () => {
			const { item_list } = this.state
			let subtotal = 0
			item_list.forEach(item => {
				subtotal += item.subtotal
			})
			return subtotal
		}
		const { loading } = this.state
		return (
			<ThemeProvider theme={theme}>
				<div style={{ position: 'relative', maxWidth: '60rem', margin: 'auto' }}>
					<div className="header">
						<Link to={'/produk/' + this.state.product_code} style={{ position: "absolute", height: 60, width: 60, top: 0, left: 0 }}>
							<img alt="icon" src={BackIcon} />
						</Link>
						<div className="center">
							<h3 className="title">Lanjutkan Pesanan</h3>
						</div>
					</div>
					<div className="wrapper-white" style={{ paddingBottom: 200, backgroundColor: '#eeeeee' }}>
						<Grid
							container
							direction="column"
							justify="center"
							alignItems="center"
						>
							{this.lineItem()}
							<Card className="order-card" style={{ textAlign: "left", width: '90%' }}>
								<Button variant="outlined" onClick={() => this.addCertificateOwner()} color="primary" style={{ textTransform: "none", height: 40, width: '100%', margin: "10px" }}>
									Tambah NIP Lainnya
								</Button>
							</Card>
							{this.deliveryAddress()}
						</Grid>
					</div>
					<div className="footer" style={{ textAlign: 'center', height: 80 }}>
						<div style={{ width: 320, margin: 'auto', paddingTop: 5, paddingBottom: 5, textAlign: 'right', fontSize: 14 }}>
							<div>Subtotal: <NumberFormat value={(subtotal())} displayType={"text"} thousandSeparator={"."} decimalSeparator={","} prefix={"Rp "} /></div>
						</div>
						<div style={{ textAlign: 'center' }}>
							<BlueButton 
								disabled={loading} 
								loading={loading} 
								onClick={this.handlePostOrder} 
								width={320} 
								text="Bayar" />
						</div>
					</div>
					{this.modalNotifSubmit()}
				</div>
			</ThemeProvider>
		);
	}
}

export default NewOrderCertificate;
